import React from 'react'
import { connect } from 'react-redux'
// import { ListView, Modal } from 'antd-mobile-v2'
import { Dialog } from 'antd-mobile'
import { Container, Wrapper, Footer, Header } from '../../components_renew/Layout'
import { YenSpan } from '../../components_renew/common/YenSpan'
import { ConfirmButton } from '../../components_renew/Mall/Buttons'
import { ShoppingCartItem } from '../../components_renew/Mall/ShoppingCartItem'
import {
  putCartItem,
  deleteCartItem,
  setOrderConfirmData,
  requestCartData
} from '../../actions/mallAction'
import { postMessage } from '../../utils'
import { withTranslation } from 'react-i18next'
// 2024/7/15 dataSource已经去掉，后续得在reducer里也一并去掉

@withTranslation()
@connect(state => {
  return state.mallCart
})
class ShoppingCart extends React.PureComponent {

  state = {
    data: this.props.data,
  }

  // 延时请求
  timeout
  delayDispatch = (func, delay = 1000) => {
    if (this.timeout) {clearTimeout(this.timeout)}
    this.timeout = setTimeout(() => {this.props.dispatch(func)}, delay)
  }

  componentDidMount () {
    const { t } = this.props
    if (!window.axios.getToken()) {
      window.toast.info(t('common.login_info_1'), 1, () => {
        // window.postMessage(JSON.stringify({ type: 'loginRequest' }), '*')
        postMessage({ type: 'loginRequest' })
      })
    } else {
      this.props.dispatch(requestCartData())
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.data !== prevProps.data) {
      this.setState({
        data: this.props.data,
      })
    }
  }

  render () {
    const {
      // dataSource,
      data
    } = this.state
    const { loading, t } = this.props
    let amount = 0
    let total = 0
    // const renderList = data.map(item => {
    //   // let { state, productCount, currentPrice } = item
    //   if (state === 1) {
    //     amount += productCount
    //     total += (productCount * currentPrice)
    //   }
    // })
    const renderList = data.map(item => {
      const { id, productId, index, productName, productCount, currentPrice, state, productPic } = item

      if (state === 1) {
        amount += productCount
        total += (productCount * currentPrice)
      }
      return <ShoppingCartItem
        key={id}
        id={id}
        index={index}
        title={productName}
        productId={productId}
        price={currentPrice}
        checked={state === 1}
        amount={productCount}
        imgSrc={productPic}
        onItemChecked={this.onItemChecked}
        onItemClick={this.onItemClick.bind(this, item)}
        onItemDelete={this.onItemDelete}
        onAmountChange={this.onAmountChange}
      />
    })
    return <Container>
      <Header loading={loading}>{t('shop_cart.title')}</Header>
      <Wrapper className={'p-2'} flex>
        {/*todo 购物车空的页面*/}
        {/*<ListView*/}
        {/*  dataSource={dataSource}*/}
        {/*  renderBodyComponent={() => <div/>}*/}
        {/*  renderRow={renderRow}*/}
        {/*  pageSize={7}*/}
        {/*  style={{ flex: '1 1 auto', overflow: 'auto' }}*/}
        {/*/>*/}
        {
          renderList
        }
      </Wrapper>
      <Footer className={'justify-between'}>
        <div style={{ padding: '1rem' }}>
          {/* 全选先不做 */}
          {/*<input type='radio' />&emsp;*/}
          <span>共 {amount} 件&emsp;{t('shop_cart.total')}： </span>
          <YenSpan>{total}</YenSpan>
        </div>
        <ConfirmButton type={'danger'} onClick={this.cartConfirm}>{t('shop_cart.payment')}</ConfirmButton>
      </Footer>
    </Container>
  }

  // event
  // 转跳到详情页
  onItemClick = item => {
    this.props.history.push(`${window.PATH.MALL_PRODUCT_DETAILS}/${item['id']}`)
  }
  // 选中购物车商品
  onItemChecked = (itemData) => {
    let data = this.state.data.map(item => {
      if (item['index'] === itemData['index']) {
        item['state'] = itemData['checked'] ? 1 : 0
      }
      return item
    })
    this.setState({ data })
    this.delayDispatch(putCartItem(itemData))
  }
  // 删除购物车商品
  onItemDelete = index => {
    Dialog.confirm(
      {
        title: '确定要删除该商品吗?',
        content: '',
        confirmText: '删除',
        cancelText: '再想一想',
        onConfirm: () => {
          let data = this.state.data.filter(item => item['index'] !== index)
          this.setState({ data })
          this.props.dispatch(deleteCartItem({ index }))
        }
      })
      .then()
  }
  // 购物车商品数量更改
  onAmountChange = itemData => {
    if (itemData.amount > 10) {
      window.toast.info('最大只能添加10个商品')
      return
    }
    let data = this.state.data.map(item => {
      if (item['index'] === itemData['index']) {
        item['productCount'] = itemData['amount']
      }
      return item
    })
    this.setState({ data })
    this.delayDispatch(putCartItem(itemData))
  }

  cartConfirm = () => {
    // let { data, amount, total } = this.props.store
    // console.log(this.state.data)
    const { t } = this.props
    let checkedData = this.state.data.filter(item => item['state'] === 1)
    if (checkedData.length > 0) {
      this.props.dispatch(setOrderConfirmData({ productList: checkedData }))
      this.props.history.push(window.PATH.MALL_ORDER_CONFIRM)
    } else {
      window.toast.info(t('shop_cart.info_1'))
    }

    // if (amount > 0) {
    //   let checkedData = data.filter(item => item.checked === '1')
    //   total = total.toFixed(2)
    //   this.props.dispatch(setOrderConfirm({ amount, total, data: checkedData }))
    //   this.props.history.push(window.PATH.MALL_ORDER_CONFIRM)
    // } else {
    //   window.toast.info('你还没选择商品哦')
    // }
  }
}

export { ShoppingCart }
